import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        'min-h-24 w-full rounded-md border border-border-strong bg-surface-raised px-3 py-2 text-sm text-ink outline-none placeholder:text-ink-subtle',
        'focus-visible:border-ink focus-visible:ring-4 focus-visible:ring-focus/25 aria-invalid:border-danger',
        className,
      )}
      {...props}
    />
  )
}
